import { useEffect, useRef } from "react";

// load the vendor script once and cache the Promise
let scriptPromise = null;
function loadChatScriptOnce() {
  if (scriptPromise) return scriptPromise;

  scriptPromise = new Promise((resolve, reject) => {
    const existing = document.getElementById("chat-script-orme");
    if (existing) {
      // If it already exists and loaded earlier, resolve immediately
      if (window.ChatWidget) return resolve(existing);
      existing.addEventListener("load", () => resolve(existing));
      existing.addEventListener("error", () => reject(new Error("chat script error")));
      return;
    }
    const s = document.createElement("script");
    s.id = "chat-script-orme";
    s.src = "https://dl1961.ormeagent.ai/chat-widget-bundled.js";
    s.async = true;
    s.onload = () => resolve(s);
    s.onerror = () => reject(new Error("Failed to load chat script"));
    document.body.appendChild(s);
  });

  return scriptPromise;
}

function hardCleanup() {
  // 1) Call vendor destroy if we kept the instance
  try {
    if (window.__chatInstance && typeof window.__chatInstance.destroy === "function") {
      window.__chatInstance.destroy();
    }
  } catch (_) {}
  window.__chatInstance = undefined;

  // 2) Remove likely injected DOM (adjust selectors if needed)
  const suspects = [
    "#chat-widget-root",
    ".chat-widget-root",
    ".orme-chat-widget",
    "[data-chat-widget]",
  ];
  suspects.forEach((sel) => {
    document.querySelectorAll(sel).forEach((n) => n.remove());
  });
}

/**
 * tabKey:
 *  - "supabase" => Agent DL
 *  - "arham"    => Agent Yensa
 */
export default function useChatWidget(tabKey) {
  const swapTokenRef = useRef(0);

  useEffect(() => {
    let cancelled = false;
    const myToken = ++swapTokenRef.current;

    async function run() {
      // Always tear down current widget first
      hardCleanup();

      // Ensure script is loaded (only loads once)
      try {
        await loadChatScriptOnce();
      } catch (e) {
        // console.error(e);
        return;
      }
      if (cancelled || myToken !== swapTokenRef.current) return;

      // Init based on active tab — SAME global: ChatWidget, DIFFERENT CONFIG
      if (typeof window.ChatWidget !== "function") return;

      try {
        if (tabKey === "supabase") {
          // === Agent DL ===
          const instance = new window.ChatWidget("body", {
            agentId: "agent_6701k3bkm5w1ebgrbbc14av6d7fs",
            domain: "dl1961trial.myshopify.com",
            accessToken: "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",
            themeColor: "#000000",
          });
          window.__chatInstance = instance;
        } else if (tabKey === "arham") {
          // === Agent Yensa ===
          const instance = new window.ChatWidget("body", {
            agentId: "agent_3201k3bb0xnmf8db49yd6cya7nsc",
            domain: "yensa.myshopify.com",
            accessToken: "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",
            themeColor: "#C20000",
          });
          window.__chatInstance = instance;
        } else {
          // any other tab: nothing mounted
        }
      } catch (_) {
        // swallow vendor init errors if needed
      }
    }

    run();
    return () => {
      cancelled = true;
      // optional: hardCleanup();
    };
  }, [tabKey]);
}


// import React, { useEffect } from "react";

// // helper to inject a script dynamically
// export default function useChatWidget(tabKey) {
//   useEffect(() => {
//     let script = null;
// console.log(tabKey,"----------------tabKey")
//     if (tabKey === "supabase") {
//       // Agent DL
//       script = document.createElement("script");
//       script.src = "https://dl1961.ormeagent.ai/chat-widget-bundled.js";
//       script.async = true;
//       script.onload = () => {
//         if (window.ChatWidget) {
//           new window.ChatWidget("body", {
//             agentId: "agent_1601k26tasqtejp9hvm2zpm9gz06",
//             domain: "dl1961trial.myshopify.com",
//             accessToken: "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",
//             themeColor: "#D67900",
//           });
//         }
//       };
//       document.body.appendChild(script);
//     }

//     if (tabKey === "arham") {
//       // Agent Yensa — replace with your real script + config
//       script = document.createElement("script");
//       script.src = "https://dl1961.ormeagent.ai/chat-widget-bundled.js";
//       script.async = true;
//       script.onload = () => {
//         if (window.YensaWidget) {
//           new window.YensaWidget("body", {
//             agentId: "agent_1901k2ytfhtdexg98r3z59knaven",
//             domain: "yensa.myshopify.com",
//             accessToken: "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",
//             themeColor: "#0044aa",
//           });
//         }
//       };
//       document.body.appendChild(script);
//     }

//     // cleanup when tab changes/unmounts
//     return () => {
//       if (script) {
//         document.body.removeChild(script);
//       }
//       // optionally also call vendor's destroy/unmount if available
//       if (window.__chatInstance?.destroy) {
//         window.__chatInstance.destroy();
//         window.__chatInstance = undefined;
//       }
//     };
//   }, [tabKey]);
// }
